module.exports = __webpack_public_path__ + "static/media/threatmetrix.262039a7.svg";